import { AsyncPipe } from '@angular/common'
import { Component, OnInit, inject } from '@angular/core'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { TbMenuComponent } from '@components-library/tb-menu'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { devStorageInstance } from '@services/local-storage/dev-storage.service'
import { ApplicationFacadeService } from '@services/store-facade'
import { environment } from 'src/environments/environment'
import { MatMenuModule } from '@angular/material/menu'

import { TranslocoModule } from '@jsverse/transloco'

@UntilDestroy()
@Component({
    selector: 'app-version',
    templateUrl: './version.component.html',
    imports: [TranslocoModule, MatMenuModule, AsyncPipe, TbIconComponent, TbMenuComponent],
})
export class VersionComponent implements OnInit {
    private readonly applicationFacadeService = inject(ApplicationFacadeService)

    version!: { branch?: string; commit?: string; date?: string; template_version: string }
    mode$ = devStorageInstance.envMode$

    ngOnInit(): void {
        this.applicationFacadeService.selectSolution$
            .pipe(untilDestroyed(this))
            .subscribe((solution) => {
                this.version = {
                    branch: environment.version.branch,
                    commit: environment.version.commit,
                    date: environment.version.date,
                    template_version: solution.version,
                }
            })
    }
}
